import { render, staticRenderFns } from "./TaskListItem.vue?vue&type=template&id=51e54ea6&scoped=true&"
import script from "./TaskListItem.vue?vue&type=script&lang=js&"
export * from "./TaskListItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskListItem.vue?vue&type=style&index=0&id=51e54ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e54ea6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/timefly-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51e54ea6')) {
      api.createRecord('51e54ea6', component.options)
    } else {
      api.reload('51e54ea6', component.options)
    }
    module.hot.accept("./TaskListItem.vue?vue&type=template&id=51e54ea6&scoped=true&", function () {
      api.rerender('51e54ea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TaskListItem.vue"
export default component.exports